// @ts-nocheck
import React, { useEffect } from 'react';
import { useHistory, BrowserRouter as Router } from 'react-router-dom';
import { GlobalStyle } from 'styles/global';

import Routes from "./routes";
import AppProvider from "./hooks";
import { HuggyWidget } from './components/bot/HuggyWidget';

export function App() {
  const history = useHistory();

  const storageUser = localStorage.getItem('@Central:user');
  const user = storageUser ? JSON.parse(storageUser) : null;

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];

    function gtag() {
      window.dataLayer.push(arguments)
    }

    gtag('js', new Date());

    gtag('config', 'G-XEZYJ0C7FC', {
      'user_id': user?.id
    });
  }, [user]);

  return (
    <Router>
      <AppProvider>
        <HuggyWidget user={user} />
        <Routes forceRefresh history={history} />
      </AppProvider>
      <GlobalStyle />
    </Router>
  );
}
